"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.actionTypes = void 0;

var _immer = _interopRequireDefault(require("immer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var actionTypes = {
  setDocument: "setDocument",
  setType: "setType",
  fetch: "fetch"
};
exports.actionTypes = actionTypes;

var reducer = function reducer(state, action) {
  return (0, _immer["default"])(state, function (draft) {
    switch (action.type) {
      case actionTypes.setDocument:
        if (!action.document) {
          break;
        }

        draft.documents[action.document._id] = action.document;
        var _type = action.document._type;

        if (!draft.types[_type]) {
          draft.types[_type] = [];
        }

        draft.types[_type].push(action.document);

        break;

      case actionTypes.setType:
        var documentType = action.documentType,
            documents = action.documents;

        if (!draft.types[documentType]) {
          draft.types[documentType] = documents;
        }

        documents.forEach(function (document) {
          draft.documents[document._id] = document;
        });
        break;

      case actionTypes.fetch:
        draft.queries[action.id] = action.result;
        break;

      default:
        break;
    }
  });
};

var _default = reducer;
exports["default"] = _default;